<template>
  <div class="consultation-container">
    <el-card class="form-card">
      <h2>{{ $t('bookDemo.title') }}</h2>
      <p class="description">{{ $t('bookDemo.desc') }}</p>
      <el-form :model="form" :rules="rules" ref="formRef" label-width="100px">
        <el-form-item :label="$t('bookDemo.name')" prop="name">
          <el-input v-model="form.name" :placeholder="$t('bookDemo.inputName')" />
        </el-form-item>
        <el-form-item :label="$t('bookDemo.phone')" prop="phone">
          <el-input v-model="form.phone" :placeholder="$t('bookDemo.inputPhone')" />
        </el-form-item>
        <el-form-item :label="$t('bookDemo.email')" prop="email">
          <el-input v-model="form.email" :placeholder="$t('bookDemo.inputEmail')" />
        </el-form-item>
        <el-form-item :label="$t('bookDemo.company')" prop="company">
          <el-input v-model="form.company" :placeholder="$t('bookDemo.inputCompany')" />
        </el-form-item>
        <el-form-item :label="$t('bookDemo.position')">
          <el-input v-model="form.position" :placeholder="$t('bookDemo.inputPosition')" />
        </el-form-item>
        <el-form-item :label="$t('bookDemo.from')">
          <el-input v-model="form.source" :placeholder="$t('bookDemo.inputFrom')" />
        </el-form-item>
        <el-form-item prop="agree">
          <el-checkbox v-model="form.agree">
            <span class="policy-link" @click="showPolicy">{{ $t('bookDemo.ConfirmClause') }}</span>
          </el-checkbox>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm">{{ $t('bookDemo.submit') }}</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-dialog :visible.sync="policyVisible" width="90%" max-width="600px">
      <template slot="title">
        <div style="text-align: center; width: 100%;font-size: 20px;">{{ $t('bookDemo.privacyPolicy.title') }}</div>
      </template>
      <div class="policy-content">
        <p>{{ $t('bookDemo.privacyPolicy.intro') }}</p>
        
        <h4>{{ $t('bookDemo.privacyPolicy.section1') }}</h4>
        <p>{{ $t('bookDemo.privacyPolicy.registrationInfo') }}</p>
        <ul>
          <li>{{ $t('bookDemo.privacyPolicy.item1') }}</li>
          <li>{{ $t('bookDemo.privacyPolicy.item2') }}</li>
          <li>{{ $t('bookDemo.privacyPolicy.item3') }}</li>
          <li>{{ $t('bookDemo.privacyPolicy.item4') }}</li>
          <li>{{ $t('bookDemo.privacyPolicy.item5') }}</li>
        </ul>
        
        <h4>{{ $t('bookDemo.privacyPolicy.section2') }}</h4>
        <p>{{ $t('bookDemo.privacyPolicy.storageLocation') }}</p>
        <p>{{ $t('bookDemo.privacyPolicy.securityMeasures') }}</p>
        
        <h4>{{ $t('bookDemo.privacyPolicy.section3') }}</h4>
        <p>{{ $t('bookDemo.privacyPolicy.accessRight') }}</p>
        <p>{{ $t('bookDemo.privacyPolicy.correctionRight') }}</p>
        <p>{{ $t('bookDemo.privacyPolicy.deletionRight') }}</p>
        <p>{{ $t('bookDemo.privacyPolicy.consentWithdrawal') }}</p>
        <p>{{ $t('bookDemo.privacyPolicy.accountDeletion') }}</p>
        
        <h4>{{ $t('bookDemo.privacyPolicy.section4') }}</h4>
        <p>{{ $t('bookDemo.privacyPolicy.changesInfo') }}</p>
        
        <h4>{{ $t('bookDemo.privacyPolicy.section5') }}</h4>
        <p>{{ $t('bookDemo.privacyPolicy.contactInfo') }}</p>
        <ul>
          <li>{{ $t('bookDemo.privacyPolicy.email') }}</li>
          <li>{{ $t('bookDemo.privacyPolicy.address') }}</li>
          <li>{{ $t('bookDemo.privacyPolicy.phone') }}</li>
        </ul>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="policyVisible = false">{{ $t('bookDemo.privacyPolicy.haveRead') }}</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        name: '',
        phone: '',
        email: '',
        company: '',
        position: '',
        source: '',
        agree: false
      },
      rules: {
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
        ],
        email: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }
        ],
        company: [{ required: true, message: '请输入公司名称', trigger: 'blur' }],
        agree: [{ validator: (rule, value, callback) => value ? callback() : callback(new Error('请阅读并同意隐私政策')), trigger: 'change' }]
      },
      policyVisible: false
    };
  },
  methods: {
    showPolicy() {
      this.policyVisible = true;
    },
    async submitForm() {
      try {
        const valid = await this.$refs.formRef.validate(); // 等待校验完成
        
        if (!valid) {
          this.$message.error('请完整填写必填信息并同意隐私政策');
          return;
        }

        const requestBody = {
          "标题": "用户试用请求",
          "内容": this.form
        };

        const response = await fetch("/api/email/send", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(requestBody)
        });

        const result = await response.json();
        console.log("邮件发送结果:", result);

        if (response.ok) {
          this.$message.success("邮件发送成功");
          // 重置表单校验状态
          this.$nextTick(() => {
            this.$refs.formRef.clearValidate();
          });
          this.form = {}; // 清空表单
        } else {
          this.$message.error("邮件发送失败");
        }
      } catch (error) {
      }
    }

  }
};
</script>

<style scoped>
.consultation-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #f5f7fa;
  padding: 20px;
  flex-direction: column;
}
.form-card {
  width: 100%;
  max-width: 700px;
  padding: 20px;
}
h2 {
  font-size: 24px;
  margin-bottom: 15px;
}
.description {
  font-size: 14px;
  color: #666;
  margin-bottom: 20px;
}
.policy-link {
  color: #409eff;
  cursor: pointer;
}
.policy-content {
  font-size: 14px;
  color: #333;
  line-height: 1.5;
  padding-left: 20px;
}

/* 移动端适配 */
@media screen and (max-width: 768px) {
  .consultation-container {
    padding: 10px;
    min-height: auto;
  }

  h2 {
    font-size: 20px;
    margin-bottom: 12px;
  }

  .description {
    font-size: 16px;
    margin-bottom: 15px;
  }

  .form-card {
    max-width: 100%;
    padding: 15px;
  }

  /* 表单元素适配 */
  .form-card::v-deep .el-form-item__label {
    font-size: 16px !important;
    margin-bottom: 8px;
    margin-top: 20px;
  }

  .form-card::v-deep .el-input__inner {
    font-size: 16px;
    height: 44px;
  }

  .form-card::v-deep .el-checkbox__label {
    font-size: 16px;
    line-height: 1.4;
  }
  .form-card /deep/ .el-button.el-button--primary span {
    font-size: 1rem;
  }

  .policy-link {
    font-size: 0.6rem;
    cursor: pointer;
    display: inline-block;
    white-space: normal;
    word-wrap: break-word;
    word-break: break-word;
  }
  .policy-content {
    font-size: 16px;
  }
  .form-card::v-deep .el-button {
    font-size: 16px;
    width: 100%;
    padding: 12px;
  }

  /* placeholder适配 */
  .form-card::v-deep .el-input__inner::placeholder {
    font-size: 14px;
  }
  .form-card /deep/ .el-checkbox {
    transform: scale(1.5); /* 整体放大 */
    transform-origin: left center; /* 避免错位 */
  }
  .form-card /deep/ .el-checkbox .el-checkbox__inner {
    width: 14px !important; /* 适当增加 */
    height: 14px !important;
  }
  .form-card /deep/ .el-checkbox .el-checkbox__inner::after {
    top: 50%;
    left: 50%;
    width: 6px; /* 调整对钩宽度 */
    height: 10px; /* 调整对钩高度 */
    border-width: 3px !important; /* 让对钩更粗 */
    transform-origin: center center;
    position: absolute;
  }
  .form-card /deep/ .el-form-item__error {
    font-size: 14px !important; /* 让提示文字变大 */
    line-height: 1.5; /* 增加行高，提高可读性 */
  }
  .form-card /deep/ .el-form-item {
    margin-bottom: 25px; /* 调整表单项之间的间距 */
  }
  .form-card /deep/ .el-form .el-form-item:nth-child(7) .el-form-item__content {
    margin-left: 20px !important;
  }
  .form-card /deep/ .el-form .el-form-item:nth-child(8) .el-form-item__content {
    margin-left: 0px !important;
  }
  .dialog-footer /deep/ .el-button span {
    font-size: 1rem !important; /* 增大文字 */
    display: block !important;  /* 让文本占满按钮 */
    line-height: 1.5 !important; /* 适当调整行高 */
  }



}
</style>